module.exports = __webpack_public_path__ + "img/1.6f7b27f8.png";